export const round = (datetime) => {
	if (datetime instanceof Date) datetime = datetime.getTime()
	return new Date(Math.floor(datetime / 1000) * 1000);
}